import axios from 'axios';
var api = axios.create({
  baseURL: 'https://api.nucleos.iclouds.com.br:3333' // baseURL: 'http://162.243.144.62:3287',

});
export default api;